import styled from "styled-components";
import Variables from "../../../../assets/styleVariables";
export const Box = styled.div`
  .add-file {
    line-height: 38px;
    font-size: ${Variables.font_sizes.x_medium};
    color: ${Variables.colors.complementary_700};
    cursor: pointer;
    padding: 8px;
    border-radius: 4px;
    &.disable {
      opacity: 0.5;
    }
    &:hover {
      background-color: ${Variables.colors.primary_50};
    }
  }
  .file-notice {
    display: flex;
    margin-top: 8px;
    max-width: 553px;
    color: ${Variables.colors.complementary_700};
    font-size: ${Variables.font_sizes.x_small};
    line-height: 1.58;
    a{
      color: ${Variables.colors.primary_vivid};
    }
    i {
      margin-left: 8px;
      &:before {
        font-size: 9px;
        color: ${Variables.colors.complementary_700};
      }
    }
  }

  .add-file-big {
    width: 88px;
    height: 88px;
    border-radius: 4px;
    border: ${Variables.colors.complementary_500} dashed 1px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 6px;
    cursor: pointer;
    &.disable{
      opacity: 0.5;
    }
    i {
      color: ${Variables.colors.complementary_700};
      &:before {
        margin-left: 0;
        font-size: 20px;
      }
    }
  }
  .input-file {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
  }
  .files {
    display: flex;
    .file {
      width: 88px;
      height: 88px;
      border-radius: 4px;
      border: ${Variables.colors.complementary_400} solid 1px;
      overflow: hidden;
      position: relative;
      margin: 0 6px;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      i {
        width: 32px;
        height: 32px;
        border-radius: 4px;
        background-color: rgba(0, 0, 0, 0.7);
        color: ${Variables.colors.complementary};
        position: absolute;
        bottom: 8px;
        right: 8px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        &:before {
          margin-left: 0;
        }
      }
    }
  }
`;
export const ModalBox = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  top: 0;
  right: 0;
  z-index: 10;
  .header {
    display: flex;
    justify-content: space-between;
    padding: 16px 32px;
    direction: ltr;
    height: 40px;
    i {
      color: ${Variables.colors.complementary};
      cursor: pointer;
    }
  }
  .path {
    padding: 48px;
    display: flex;
    height: calc(100% - 140px);
    justify-content: center;
    align-items: center;
    width: 100%;
    .next,
    .prev {
      width: 48px;
      height: 96px;
      background-color: rgba(256, 256, 256, 0.2);
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      i {
        color: rgba(256, 256, 256, 0.4);
        &:before {
          font-size: 38px;
          margin: 0;
        }
      }
    }
    .next {
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
      //here
      position: absolute;
      left: 0;
    }
    .prev {
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
      position: absolute;
      right: 0;
    }
    img {
      height: 100%;
    }
  }
  .footer {
    background-color: rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
    img {
      border-radius: 4px;
      margin: 8px;
      cursor: pointer;
      width: 72px;
      height: 72px;
      border: solid 1px ${Variables.colors.complementary_400};
    }
  }
`;
